export const isOtherAllowedInput = (charCode: number, e: any) => {
    return (
        [8, 186, 46, 8, 9, 27, 13, 110, 190, 37, 39].indexOf(charCode) > -1 ||
        ((charCode == 65 || charCode == 86 || charCode == 82 || charCode == 67) && (e.ctrlKey === true || e.metaKey === true)))
}

export const isNumberInput = (charCode: number) => {
    return (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)
}